export default "__VITE_ASSET__DFplnxTN__"